import React from 'react';
import { ChecklistBannerVariant } from '../../handoff-checklist-v2.types';
import { SuccessStatusBanner } from './success-status-banner';
import { BlockedStatusBanner } from './blocked-status-banner';
import { WarningStatusBanner } from './warning-status-banner';
import { ExceptionNotedStatusBanner } from './exception-noted-status-banner';

interface ChecklistStatusBannerProps {
  variant: ChecklistBannerVariant;
  successMessage?: string;
  blockedCount: number;
  blockedMetricNames: string[];
  exceptionNotedCount: number;
  exceptionNotedMetricNames: string[];
  onRefresh: () => void;
  onTakeNotes: () => void;
  onReviewOptional: () => void;
}

export const ChecklistStatusBanner = ({
  variant,
  successMessage,
  blockedCount,
  blockedMetricNames,
  exceptionNotedCount,
  exceptionNotedMetricNames,
  onRefresh,
  onTakeNotes,
  onReviewOptional,
}: ChecklistStatusBannerProps) => {
  if (variant === ChecklistBannerVariant.SUCCESS) {
    return (
      <SuccessStatusBanner successMessage={successMessage} onTakeNotes={onTakeNotes} />
    );
  }

  if (variant === ChecklistBannerVariant.BLOCKED) {
    return (
      <BlockedStatusBanner
        blockedCount={blockedCount}
        blockedMetricNames={blockedMetricNames}
        onRefresh={onRefresh}
      />
    );
  }

  if (variant === ChecklistBannerVariant.EXCEPTION_NOTED) {
    return (
      <ExceptionNotedStatusBanner
        exceptionNotedCount={exceptionNotedCount}
        exceptionNotedMetricNames={exceptionNotedMetricNames}
        onRefresh={onRefresh}
      />
    );
  }

  if (variant === ChecklistBannerVariant.WARNING) {
    return <WarningStatusBanner onReviewOptional={onReviewOptional} />;
  }

  return null;
};
